import React from "react";
import ReactDOM from "react-dom/client";
import NinjaType from "./ninjatype"; // import your component

// ✅ register it


import "./ninjatype.css"; // your styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<NinjaType />);
